import request from '@/utils/request'
import store from '@/store'

const endpoint = '/api/admin/v1/'

export function clientAuth (data) {
  const opt = {
    url: endpoint + store.getters['app/lang'] + '/login',
    method: 'POST',
    data
  }
  return request(opt)
}

export function postLogin (data) {
  const opt = {
    url: store.getters['app/lang'] + endpoint,
    method: 'POST',
    data
  }
  return request(opt)
}

export function refreshToken (data) {
  const opt = {
    url: endpoint + store.getters['app/lang'] + '/refresh',
    method: 'POST',
    data
  }
  return request(opt)
}

export function postLogout () {
  const opt = {
    url: endpoint + store.getters['app/lang'] + '/logout',
    method: 'POST'
  }
  return request(opt)
}

export function postRegis (data) {
  const opt = {
    url: endpoint + store.getters['app/lang'] + '/register',
    method: 'POST',
    data
  }
  return request(opt)
}

export function forgetPassword (data) {
  const opt = {
    url: endpoint + store.getters['app/lang'] + '/forget-password',
    method: 'POST',
    data
  }
  return request(opt)
}

export function resetPassword (data) {
  const opt = {
    url: endpoint + store.getters['app/lang'] + '/reset-password',
    method: 'POST',
    data
  }
  return request(opt)
}

export function verification (data) {
  const opt = {
    url: endpoint + store.getters['app/lang'] + '/verification',
    method: 'POST',
    data
  }
  return request(opt)
}

export function verifyEmail (data) {
  const opt = {
    url: endpoint + store.getters['app/lang'] + '/email/verify',
    method: 'GET',
    params: data
  }
  return request(opt)
}

export function getAccount (token) {
  if (typeof token.access_token !== 'undefined') {
    const opt = {
      url: endpoint + store.getters['app/lang'] + '/me',
      method: 'GET'
    }
    return request(opt)
  }
}
